<template>
    <b-overlay
        :show="showOverlay"
        rounded="sm"
        spinner-variant="primary"
        spinner-small
    >
        <b-row class="pb-2">
            <b-col>
                <h4 v-if="null === id">
                    {{ $t('Page(SubscriberCard):Component(Text):add') }}
                </h4>
                <h4 v-else>
                    {{ $t('Page(SubscriberCard):Component(Text):edit', {subscriber: subscriber.title}) }}
                </h4>
            </b-col>
            <b-col md="6" lg="6">
                <Actions
                    class="float-right"
                    :is-manage-root-organization-visible="isManageOrganizationButtonVisible"
                    @save="save"
                    @close="close"
                    @manageRootOrganization="manageRootOrganization"
                />
            </b-col>
        </b-row>
        <b-row v-if="!isProperlyConfigured" class="pb-1">
            <b-col>
                <b-alert
                    show
                    variant="danger"
                    class="mb-50"
                >
                    <h4 class="alert-heading">
                        Configuration issue
                    </h4>
                    <div class="alert-body">
                        Subscriber or Subscriber's root organization has not been configured properly!
                        <ul>
                            <li v-if="!subscriber.isManageable">
                                Subscriber is not manageable - presumably configuration has not finished yet
                            </li>
                            <li v-if="!subscriber.organization">
                                Subscriber doesn't have root organization unit
                            </li>
                        </ul>
                    </div>
                </b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" lg="6">
                <GeneralInfo
                    ref="generalInfo"
                    :general-info="subscriber"
                    @input="onGeneralInfoChange"
                />
            </b-col>
            <b-col md="6" lg="6">
                <Subscriptions
                    ref="subscription"
                    @update="onSubscriptionUpdate"
                    @create="onSubscriptionCreate"
                    :subscriptions="subscriptions"
                />
                <Settings
                    ref="settings"
                    :settings="subscriber.settings"
                    @input="onSettingsChange"
                />
            </b-col>
        </b-row>
    <!--        <b-row>-->
    <!--            <b-col md="6" lg="6">-->
    <!--                <LegalIdentities-->
    <!--                    :identities="legalIdentities"-->
    <!--                    @add="addLegalIdentity"-->
    <!--                    @remove="removeLegalIdentity"-->
    <!--                    @change="legalIdentityChange"-->
    <!--                />-->
    <!--            </b-col>-->
    <!--            <b-col md="6" lg="6">-->
    <!--                <Domains-->
    <!--                    :domains="domains"-->
    <!--                    @add="addDomain"-->
    <!--                    @remove="removeDomain"-->
    <!--                    @change="updateDomain"-->
    <!--                />-->
    <!--            </b-col>-->
    <!--        </b-row>-->
    </b-overlay>
</template>

<script>
import {SubscriberApi} from "@core/api";
import {BRow, BCol, BOverlay, BAlert} from 'bootstrap-vue'
import Actions from "@/views/administration/subscriber/components/Actions";
import GeneralInfo from "@/views/administration/subscriber/components/GeneralInfo";
import Settings from "@/views/administration/subscriber/components/Settings";
import Subscription from "@/views/administration/subscriber/components/Subscription";
import backendResponse from "@core/mixins/ui/backend-response";
import Domains from "@/views/administration/subscriber/components/Domains.vue";
import LegalIdentities from "@/views/administration/subscriber/components/LegalIdentities.vue";
import LegalIdentitiesSupport from "@/views/administration/subscriber/mixin/LegalIdentitiesSupport.vue";
import DomainsSupport from "@/views/administration/subscriber/mixin/DomainsSupport.vue";
import Subscriptions from "@/views/administration/subscriber/components/Subscriptions.vue";
import SubscriptionsSupport from "@/views/administration/subscriber/mixin/SubscriptionsSupport.vue";

export default {
    mixins: [backendResponse, LegalIdentitiesSupport, DomainsSupport, SubscriptionsSupport],
    props: {
        id: {
            required: true
        }
    },
    components: {
        Subscriptions,
        LegalIdentities, Domains,
        BOverlay, BRow, BCol, Actions, GeneralInfo, Settings, Subscription, BAlert,
    },
    data() {
        return {
            subscriber: {
                settings: {}
            },
            subscription: null,
            showOverlay: true,
            subscriptions: []
        };
    },
    methods: {
        onGeneralInfoChange(generalInfo) {
            this.subscriber.title = generalInfo.title;
            this.subscriber.description = generalInfo.description;
            this.subscriber.comment = generalInfo.comment;
        },
        onSettingsChange(settings) {
            this.subscriber.settings = settings;
        },
        onSubscriptionChange(subscription) {
            this.subscription = {
                validFrom: subscription.validFrom,
                validTo: subscription.validTo,
            };
        },
        save() {
            Promise.all([
                this.$refs.generalInfo.validate(),
                this.$refs.settings.validate(),
                this.subscription ? this.$refs.subscription.validate() : true,
            ]).then((events) => {
                if (events.includes(false)) {
                    return;
                }
                this.showOverlay = true;
                const subscriber = {
                    ...this.subscriber,
                    legalIdentities: this.legalIdentities.map(li => {
                        return {
                            type: li.type ? li.type.id : null,
                            value: li.value
                        }
                    }),
                    domains: this.domains
                }
                SubscriberApi
                    .update(subscriber, this.subscriptions)
                    .then(r => {
                        this.showDefaultSuccessMessage('Subscriber has been successfully updated');
                        return this.fetch();
                    })
                    .catch(this.handleBackendError)
                    .finally(() => {
                        this.showOverlay = false;
                    });
            })
        },
        close() {
            this.$router.go(-1);
        },
        manageRootOrganization() {
            let gotoOrganization = () => {
                this.$router.push({
                    name: 'administration-internal-edit',
                    params: {id: this.subscriber.organization.id}
                });
            };
            if (this.$store.state.user.organization.id !== this.subscriber.organization.id) {
                this.$swal({
                    title: 'Good job!',
                    text: 'To manage organization unit we have to switch your account to this organization',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Switch and manage!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1',
                    },
                    buttonsStyling: false,
                }).then(result => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch('selectOrganization', {
                                id: this.subscriber.organization.id,
                                title: this.subscriber.organization.title,
                            })
                            .then(() => {
                                gotoOrganization();
                            })
                    }
                })
            } else {
                gotoOrganization();
            }
        },
        fetch() {
            return SubscriberApi.get(this.id).then(r => {
                this.subscriber = r.data;
                this.legalIdentities = r.data.legalIdentities;
                this.domains = r.data.domains.map(d => d.domain);
                this.subscription = r.data.subscription || null;
                this.subscriptions = r.data.subscriptions || [];
                this.showOverlay = false;
            });
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        isProperlyConfigured() {
            return this.subscriber.isManageable && this.subscriber.organization;
        },
        isManageOrganizationButtonVisible() {
            return this.isProperlyConfigured;
        }
    }
}
</script>
